<div class="step-success">
  <div class="success-icon">✓</div>
  <h2 class="success-title">{{ successTitle }}</h2>
  <p class="success-subtitle">{{ successSubtitle }}</p>

  <div class="week-chips">
    @for (day of weekDays; track day) {
      <span class="week-chip">{{ day }}</span>
    }
  </div>

  <button type="button" class="btn btn--primary" (click)="onPrimaryAction()">
    {{ primaryActionLabel }}
  </button>
  @if (action() === 'queue') {
    <a
      class="btn btn--ghost success-link"
      href="/post-schedule"
      target="_blank"
      rel="noopener noreferrer"
    >
      View posting times ↗
    </a>
  }
  <button type="button" class="btn btn--ghost" (click)="onCreateAnother()">
    Create another set
  </button>
</div>
